/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ExtendAgentKeysForm,
  ExtendAgentKeysForm$Outbound,
  ExtendAgentKeysForm$outboundSchema,
} from "../components/extendagentkeysform.js";

export type ExtendAgentAPIKeysSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ExtendAgentAPIKeysRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  extendAgentKeysForm: ExtendAgentKeysForm;
};

/** @internal */
export type ExtendAgentAPIKeysSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ExtendAgentAPIKeysSecurity$outboundSchema: z.ZodMiniType<
  ExtendAgentAPIKeysSecurity$Outbound,
  ExtendAgentAPIKeysSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function extendAgentAPIKeysSecurityToJSON(
  extendAgentAPIKeysSecurity: ExtendAgentAPIKeysSecurity,
): string {
  return JSON.stringify(
    ExtendAgentAPIKeysSecurity$outboundSchema.parse(extendAgentAPIKeysSecurity),
  );
}

/** @internal */
export type ExtendAgentAPIKeysRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  ExtendAgentKeysForm: ExtendAgentKeysForm$Outbound;
};

/** @internal */
export const ExtendAgentAPIKeysRequest$outboundSchema: z.ZodMiniType<
  ExtendAgentAPIKeysRequest$Outbound,
  ExtendAgentAPIKeysRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    extendAgentKeysForm: ExtendAgentKeysForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      extendAgentKeysForm: "ExtendAgentKeysForm",
    });
  }),
);

export function extendAgentAPIKeysRequestToJSON(
  extendAgentAPIKeysRequest: ExtendAgentAPIKeysRequest,
): string {
  return JSON.stringify(
    ExtendAgentAPIKeysRequest$outboundSchema.parse(extendAgentAPIKeysRequest),
  );
}
